<div class="po-row">
  <po-widget [ngClass]="cardClass" p-title="Solicitações de review">
    <p class="po-font-display">{{ totalLabel }}<span class="review-stats-kpis__unit">solicitações</span><span
      class="po-icon po-icon-info review-stats-kpis__help"
      [p-tooltip]="cardHelp.totals" p-tooltip-position="bottom" p-append-in-body="true"></span></p>
    <po-tag *ngIf="totalChange as change" class="review-stats-kpis__tag" p-type="info"
      [p-value]="change.label + ' vs. período anterior'"></po-tag>
    <po-info *ngIf="totalChange" p-label="Período anterior" [p-value]="previousTotalLabel"
      p-orientation="horizontal"></po-info>
    <po-info *ngIf="hasTotals" p-label="Recursos distintos" [p-value]="uniqueResourcesLabel"
      p-orientation="horizontal"></po-info>
    <po-info *ngIf="hasTotals" p-label="Solicitações concluídas" [p-value]="doneLabel"
      p-orientation="horizontal"></po-info>
  </po-widget>

  <po-widget [ngClass]="cardClass" p-title="Achados por review (mediana)">
    <p class="po-font-display">{{ findingsMedianLabel }}<span class="review-stats-kpis__unit">achados</span><span
      class="po-icon po-icon-info review-stats-kpis__help" [p-tooltip]="cardHelp.findings"
      p-tooltip-position="bottom" p-append-in-body="true"></span></p>
    <po-tag *ngIf="findingsChange as change" class="review-stats-kpis__tag"
      [p-type]="change.flat ? 'info' : (change.up ? 'danger' : 'success')"
      [p-value]="change.label + ' vs. período anterior'"></po-tag>
    <po-info *ngIf="hasFindingsSplit" p-label="P90 — 9 em cada 10 reviews têm até" [p-value]="findingsP90Label" p-orientation="horizontal"></po-info>
    <po-info *ngIf="hasFindingsSplit" p-label="Média" [p-value]="findingsPerReviewLabel" p-orientation="horizontal"></po-info>
    <po-info p-label="Base do cálculo" [p-value]="findingsBaseLabel" p-orientation="horizontal"></po-info>
    <po-info *ngIf="hasUnknownFindings" p-label="Dado incompleto" [p-value]="unknownFindingsLabel"
      p-orientation="horizontal"></po-info>
  </po-widget>

  <po-widget *ngIf="serviceView && hasDurationBlock" [ngClass]="cardClass" p-title="Tempo até o resultado (P90)">
    <p class="po-font-display" *ngIf="hasDuration; else noDuration">{{ p90DurationLabel }}<span
      class="po-icon po-icon-info review-stats-kpis__help" [p-tooltip]="cardHelp.duration"
      p-tooltip-position="bottom" p-append-in-body="true"></span></p>
    <ng-template #noDuration><p class="po-font-display">—</p></ng-template>
    <po-tag *ngIf="durationChange as change" class="review-stats-kpis__tag"
      [p-type]="change.flat ? 'info' : (change.up ? 'danger' : 'success')"
      [p-value]="change.label + ' vs. período anterior'"></po-tag>
    <po-info *ngIf="hasDuration" p-label="Mediana" [p-value]="medianDurationLabel"
      p-orientation="horizontal"></po-info>
  </po-widget>

  <po-widget *ngIf="serviceView" [ngClass]="cardClass" p-title="Falso positivo">
    <p class="po-font-display">{{ falsePositive?.rate || '—' }}<span
      class="po-icon po-icon-info review-stats-kpis__help" [p-tooltip]="cardHelp.falsePositive"
      p-tooltip-position="bottom" p-append-in-body="true"></span></p>
    <po-info *ngIf="falsePositive" p-label="Votos" [p-value]="falsePositive.votes"
      p-orientation="horizontal"></po-info>
  </po-widget>
</div>
